import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "repliesContainer",
    "replyForm",
  ]

  connect(){
    if (this.hasReplyFormTarget){
      this.replyFormTarget.addEventListener("turbo:submit-end", (e) => {
        const { detail: { success } } = e
  
        if (success){
          this.replyFormTarget.reset()
          this.hideReplyForm()
        }
      })
    }
  }
  
  showReplyForm(){
    if (this.hasReplyFormTarget){
      this.replyFormTarget.classList.replace("hidden", "visible")
    }

    if (this.hasRepliesContainerTarget){
      this.repliesContainerTarget.classList.replace("hidden", "visible")
    }
  }

  hideReplyForm(){
    if (this.hasReplyFormTarget){
      this.replyFormTarget.classList.replace("visible", "hidden")
    }

    if (this.hasRepliesContainerTarget){
      this.repliesContainerTarget.classList.replace("visible", "hidden")
    }
  }
}
